<div *ngIf="isLastArticle && articles" class="article-card d-flex justify-content-center" (click)="goTo(articles)">
  <div class="article-container d-flex overflow-hidden row m-0 gap-0">

      <div class="photo-container position-relative overflow-hidden">
        <div class="badge" *ngIf="firstTag(articles) as tag">
          <img class="tag-icon" *ngIf="tag.icon" [src]="tag.icon" alt="Icon représentative de nos articles" />
          {{ tag.text }}
        </div>
        <img [src]="articles['banner']" [alt]="articles['altBanner']" class="d-flex img-last-cover">

      </div>

    <div class="padding-text">
      <h3 class="text-ellipsis title_2">{{ articles['pageTitle'] }}</h3>
      <div class="text-container pt-3 d-flex flex-column text-black">
        <div class="pt-2 text_1 txt-darkGray pageDescription" [ngClass]="{'mobileDescription': isMobile}">
          <p [innerHTML]="articles['pageDescription']">
          </p>
        </div>
      </div>
      <div class="d-flex pt-4 pe-4 justify-content-between" *ngIf="getAgentInfo(articles.author_id) as agent">
        <span class="d-flex align-items-center gap-2 ">
          <img width="32" [src]="getAgentAvatar(articles.author_id)" class="mx-auto" />
          <p class="d-flex text-align-center fw-bold">{{agent.firstname}}</p>
        </span>
        <p class="d-flex align-items-center">{{ articles['publicationDate'] | date:'shortDate':'':'fr' }}</p>
      </div>
    </div>
  </div>
</div>
